module.exports = __webpack_public_path__ + "static/media/finport-logo-white.1db84f70.jpg";